@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        @if (!isEmbeddedMode) {
            <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Responsible Entities"></ws-bread-crumbs>
        }
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">
                    Responsible Entities
                    <ag-grid-row-count [gridApi]="gridApi" [gridTracker]="gridTracker" [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    @if (canEdit) {
                        <div class="ws-section__header__actions__item">
                            @if (!siteId && !parcelId) {
                                <button
                                    type="button"
                                    class="ace-btn btn-primary btn-sm"
                                    (click)="addResponsibleEntity()"
                                    helpTooltip
                                    helpContentId="asset-list.new-asset"
                                    position="bottom"
                                >New Responsible Entity
                                </button>
                            }
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        <button type="button" class="ace-btn btn-sm has-icon btn-secondary" (click)="refresh()" helpTooltip helpContentId="app.refresh" position="bottom" [disabled]="refreshing">
                            <i class="fa fa-refresh"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <ws-ag-grid-angular (gridReady)="onAgGridReady($event)"
                            [companyId]="companyId"
                            [gridOptions]="gridOptions"
                            [gridId]="gridId"
                            [exportOptions]="exportOptions"
                            [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                            [defaultSizeToFit]="false">
        </ws-ag-grid-angular>
    </div>
}
